import { METHOD } from './method'

export const API_HEADER_BANNER = {
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/header-banner',
        method: METHOD.GET,
    },
    URL_HEADER_BANNER: {
        api: '/v1/dashboard-admin/general-setting/header-banner/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/header-banner',
        method: METHOD.PUT,
    },
}
